import get from 'lodash/get';
import isNil from 'lodash/isNil';

import { getCloudinaryVideoPublicId } from 'utils/cloudinary';

import type { GalleryModalItem } from 'types';
import type {
  ContentGalleryItem,
  ContentGalleryItemSize
} from '../types';

export const DEFAULT_ITEM_SIZE = 150;

export const prepareItemsForGallery = (
  items: Array<ContentGalleryItem>
): Array<GalleryModalItem> => (
  items.map(item => {
    if (item.assetType === 'video' || item.mediaType === 'video') {
      return ({
        id: item.id,
        type: 'cloudinary-video',
        assetUrl: item.url,
        url: item.url,
        isSelected: item.isSelected || false,
        cloudinaryVideoId: get(item, 'meta.cloudinary.publicId', getCloudinaryVideoPublicId(item.url)),
        bucketId: item.bucketId
      });
    }

    return ({
      id: item.id,
      type: 'cloudinary-image',
      assetUrl: item.url,
      url: item.url,
      isSelected: item.isSelected || false,
      bucketId: item.bucketId
    });
  })
);

export const getItemSize = (
  sizeString?: ContentGalleryItemSize
): number => {
  if (isNil(sizeString) || !/size-/.test(sizeString)) {
    return DEFAULT_ITEM_SIZE;
  }

  return Number(sizeString.replace(/size-/, ''));
};
